module.exports = __webpack_public_path__ + "img/pres-08.10c03815.png";